import React from "react";
import { ShieldCheck } from "lucide-react";

const SecurityMessage = () => {
  return (
    <div 
      className="flex items-center justify-center gap-2 text-sm text-slate-600 py-8"
      data-testid="security-message"
    >
      <ShieldCheck className="h-5 w-5 text-emerald-600" />
      <span>Connexion sécurisée et cryptée SSL</span>
    </div>
  );
};

export default SecurityMessage;
